export class LoginFormModel {
  constructor(data = {}) {
    this.email = data?.email || "";
    this.password = data?.password || "";
  }
}
